<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <div class="row">
          <div class="col-md-12">
            <card class="card-tasks" title="Évolution des visites" subTitle="Sur les 30 derniers jours">
              <div class="stats">
                <chart-analytics
                  v-if="contentsAnalytics.visits"
                  :height="250"
                  :metrics="contentsAnalytics"></chart-analytics>
              </div>
            </card>
          </div>
        </div>
      </transition>
    </div>
    <!-- <pre>{{ contentsAnalytics }}</pre> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ChartAnalytics from '../../components/ChartAnalytics.js';

export default {
  computed: mapGetters({
    contentsAnalytics: 'contentsAnalytics'
  }),
  components: {
    ChartAnalytics
  },
  data () {
    return {
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.loading = true
      this.$store.dispatch('getContentsAnalytics', {}).then(() => {
        this.loading = false
      })
    }
  }
}

</script>
<style>

</style>
